import Vue from "vue";
import VueRouter from "vue-router";


import register from './components/login/register.vue'
import forgetpassword from './components/login/forgetpassword.vue'

import header from './components/common/header.vue'


// 要告诉 vue 使用 vueRouter
Vue.use(VueRouter);


const routes = [
	// {
	//     path: '/',
	//     name: 'index',
	// 	component: resolve => require(['./components/index/index.vue'], resolve),
	// },
	
	{
	    path: '/agreement',
	    name: 'agreement',
		component: resolve => require(['./components/agreement/agreement.vue'], resolve),
	},
	{
	    path: '/login',
	    name: 'login',
		component: resolve => require(['./components/login/login.vue'], resolve),
	},
	{
	    path: '/register',
	    name: 'register',
		component: resolve => require(['./components/login/register.vue'], resolve),
	},
	
	{
	    path:"/",
	    component: header,
		 redirect:'/index', // 设置默认打开的页面
		children: [
			{
			    path: '/index',
			    name: 'index',
				component: resolve => require(['./components/index/index.vue'], resolve),
			},
			{
			    path: '/question/details',
			    name: 'question/details',
				component: resolve => require(['./components/question/details.vue'], resolve),
			},
			{   //用户
				path: '/user',
				redirect:'/question', // 设置默认打开的页面
				component: resolve => require(['./components/common/user/user.vue'], resolve),
				children: [
					{
					    path: '/centre',
					    name: 'user/centre',
						component: resolve => require(['./components/user/centre.vue'], resolve),
					},
					{
					    path: '/bean',
					    name: 'user/bean',
						component: resolve => require(['./components/user/bean.vue'], resolve),
					},
					{
					    path: '/competition',
					    name: 'user/competition',
						component: resolve => require(['./components/user/competition.vue'], resolve),
					},
					{
					    path: '/question',
					    name: 'user/question',
						component: resolve => require(['./components/user/question.vue'], resolve),  //题库
					},
					{
					    path: '/updpass',
					    name: 'user/updpass',
						component: resolve => require(['./components/user/updpass.vue'], resolve),  //修改密码
					},
					{
					    path: '/attention',
					    name: 'user/attention',
						component: resolve => require(['./components/user/attention.vue'], resolve),  //我的关注
					},
					{
					    path: '/authentication',
					    name: 'user/authentication',
						component: resolve => require(['./components/user/authentication.vue'], resolve),  //认证
					},
					{
					    path: '/dingyue',
					    name: 'user/dingyue',
						component: resolve => require(['./components/user/dingyue.vue'], resolve),  //订阅
					},
					{
					    path: '/tixing',
					    name: 'user/tixing',
						component: resolve => require(['./components/user/tixing.vue'], resolve),  //题型
					},
					
					
				]
			},
			{   //用户
				path: '/touser',
				redirect:'/touser_question', // 设置默认打开的页面
				component: resolve => require(['./components/common/touser/touser.vue'], resolve),
				children: [
					{
					    path: '/touser_gameall',
					    name: 'touser_gameall',
						component: resolve => require(['./components/touser/gameall.vue'], resolve),
					},
					{
					    path: '/touser_question',
					    name: 'touser/question',
						component: resolve => require(['./components/touser/question.vue'], resolve),
					},
					{
					    path: '/touser_tixing',
					    name: 'touser_tixing',
						component: resolve => require(['./components/touser/tixing.vue'], resolve),
					},
					
				]
			},
			{
				path: '/sponsor',
				redirect:'/sponsor_gameall', // 设置默认打开的页面
				component: resolve => require(['./components/common/sponsor/sponsor.vue'], resolve),
				children: [
					{
					    path: '/sponsor_gameall',
					    name: 'sponsor_gameall',
						component: resolve => require(['./components/sponsor/gameall.vue'], resolve),  //赛事列表
					},
					{
					    path: '/sponsor_question',
					    name: 'sponsor_question',
						component: resolve => require(['./components/sponsor/question.vue'], resolve),  //题型
					},
					{
					    path: '/sponsor_bank',
					    name: 'sponsor_bank',
						component: resolve => require(['./components/sponsor/bank.vue'], resolve),  //题库
					},
					{
					    path: '/sponsor_article',
					    name: 'sponsor_article',
						component: resolve => require(['./components/sponsor/article.vue'], resolve),  //文章
					},
					{
					    path: '/sponsor_books',
					    name: 'sponsor_books',
						component: resolve => require(['./components/sponsor/books.vue'], resolve),  //推荐书籍
					},
					
				]
			},
			{
				path: '/author',
				redirect:'/author_question', // 设置默认打开的页面
				component: resolve => require(['./components/common/author/author.vue'], resolve),
				children: [
				
					{
					    path: '/author_question',
					    name: 'authorr_question',
						component: resolve => require(['./components/author/question.vue'], resolve),  //题型
					},
					{
					    path: '/author_bank',
					    name: 'author_bank',
						component: resolve => require(['./components/author/bank.vue'], resolve),  //题库
					},
					{
					    path: '/author_article',
					    name: 'author_article',
						component: resolve => require(['./components/author/article.vue'], resolve),  //文章
					},
					{
					    path: '/author_books',
					    name: 'author_books',
						component: resolve => require(['./components/author/books.vue'], resolve),  //推荐书籍
					},
					
					
					
					
				]
			},
			
			{
				path: '/articledetails',
				name: 'articledetails',
				component: resolve => require(['./components/sponsor/articledetails.vue'], resolve),  //文章详情
					
			},
			{
				path: '/topic/exercise',
				name: 'topic/exercise',
				component: resolve => require(['./components/topic/exercise.vue'], resolve),  //试库练习
				
			},
			{
				path: '/topic/exercise1',
				name: 'topic/exercise1',
				component: resolve => require(['./components/topic/exercise1.vue'], resolve),  //考试练习
				
			},
			{
				path: '/topic/beaker',
				name: 'topic/beaker',
				component: resolve => require(['./components/topic/beaker.vue'], resolve),  //题型练习
				
			},
			{
				path: '/topic/exam',
				name: 'topic/exam',
				component: resolve => require(['./components/topic/exam.vue'], resolve),  //考试
				
			},
			{
				path: '/game/list',
				name: 'game/list',
				component: resolve => require(['./components/game/list.vue'], resolve),  //比赛列表
				
			},
			{
				path: '/game/details',
				name: 'game/details',
				component: resolve => require(['./components/game/details.vue'], resolve),  //比赛详情
				
			},
			{
				path: '/question/ku_list',
				name: 'question/ku_list',
				component: resolve => require(['./components/question/ku_list.vue'], resolve),  //题库列表
				
			},
			{
				path: '/question/ti_list',
				name: 'question/ti_list',
				component: resolve => require(['./components/question/ti_list.vue'], resolve),  //题型列表
				
			},
			{
				path: '/article/list',
				name: 'article/list',
				component: resolve => require(['./components/article/list.vue'], resolve),  //文章列表
				
			},
			{
				path: '/exercise/list',
				name: 'exercise/list',
				component: resolve => require(['./components/exercise/list.vue'], resolve),  //记录列表
				
			},
			{
				path: '/exercise/details',
				name: 'exercise/details',
				component: resolve => require(['./components/exercise/details.vue'], resolve),  //记录详情
			},
			{
				path: '/exercise/details1',
				name: 'exercise/details1',
				component: resolve => require(['./components/exercise/details1.vue'], resolve),  //记录详情
			},
		],
	},

    
]

var router =  new VueRouter({
    routes
	// ,
	// mode:'history'
})
export default router;